export enum EnumCriticidad {
  Grave = 1,
  Media,
  Leve
}